import React, { createContext, useState } from 'react';

import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import { cubictheme } from './assets/cubictheme';
import Login from './components/modules/authentication/login';
import { Routes, Route, Link } from "react-router-dom";
import { AxiosInterceptor } from './components/services/api.interceptor';
import Main from './components/layout/main';
import Dashboard from './components/modules/dashboard/dashboardmain';
import Magnetic from './components/modules/magnetic/magneticmain';
import ITSO from './components/modules/itso/itsomain';
import Jobs from './components/modules/jobs/jobsmain';
import Users from './components/modules/users/usersmain';
import Settings from './components/modules/settings/settingsmain';
import MasterList from './components/modules/masterlist/masterlist';
import LoginNew from './components/modules/authentication/login_new';
import About from './components/modules/about/aboutmain';
import Configuration from './components/modules/configuration/configurationmain';
import BulkImport from './components/modules/bulkimport/bulkimportmain';
import Reports from './components/modules/reports/reportsmain';
interface IsEdited {
  isEdited: boolean,
  setIsEdited: (newValue: boolean) => void

}
export const IsEditedContext = createContext<IsEdited>({
  isEdited: false,
  setIsEdited: (newValue: boolean) => { }
});
function App() {
  const [isEdited, setIsEdited] = useState(false);
  return (
    <IsEditedContext.Provider value={{ isEdited, setIsEdited }}>
    <ThemeProvider theme={cubictheme}>
      <Routes>
          <Route path="/" element={<Main body={<Dashboard />} />} />
          <Route path="/dashboard" element={<Main body={<Dashboard />} />} />
          <Route path="/magnetic" element={<Main body={<Magnetic />} />} />
          <Route path="/itso" element={<Main body={<ITSO />} />} />
          <Route path="/jobs" element={<Main body={<Jobs />} />} />
          <Route path="/users" element={<Main body={<Users />} />} />
          <Route path="/settings" element={<Main body={<Settings />} />} />
          <Route path="/masterlist" element={<Main body={<MasterList />} />} />
          <Route path="/about" element={<Main body={<About />} />} />
          <Route path="/configuration" element={<Main body={<Configuration />} />} />
          <Route path="/bulkimport" element={<Main body={<BulkImport/>}/>}/>
          <Route path="/reports" element={<Main body={<Reports />} />} />
          
        </Routes> </ThemeProvider>
        </IsEditedContext.Provider>
  );
}

export default App;
